import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../api.js';

export function PurchasePending() {
  const { purchaseId } = useParams();
  const nav = useNavigate();

  async function cancel() {
    if (!purchaseId) return;
    try {
      await api('POST', `/api/purchases/${purchaseId}/cancel`);
    } catch {}
    nav('/', { replace: true });
  }

  return (
    <div className="page pending">
      <h1>Go to the kiosk</h1>
      <p>
        Your purchase is waiting at the honesty-box kiosk. Scan the QR code there with your
        banking app to complete payment.
      </p>
      <p className="hint">
        Reference code{' '}
        <code>{(purchaseId ?? '').slice(-4).toUpperCase()}</code>
      </p>
      <button onClick={cancel} className="danger">
        Give up
      </button>
    </div>
  );
}
